export default "__VITE_ASSET__BmlPtgMh__"